import React, { useEffect, useMemo, useState } from "react";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import ajaxSchool from "../../util/remote/ajaxSchool";
import { useTheme } from "../../DataStore/ThemeContext";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import Notification from "../../components/Common/Notification";
import AlertNotification from "../../components/Common/AlertNotification";
import { useSchool } from "../../DataStore/SchoolContext";
import PageTitle from "../../components/Common/PageTitle/PageTitle";


const FeesVotesPage = () => {
const {openSettings, setNotify} = useTheme();
const [showDeleteFeesVote, setShowDeleteFeesVote] = useState(false);
const {getFeesVotes, feesVoteListing} = useSchool();
const [selectedVote, setSelectedVote] = useState(null);

useEffect(()=>{
    getFeesVotes();
}, [])

const votes = useMemo(()=>{
    return Array.isArray(feesVoteListing) ? feesVoteListing : [];
}, [feesVoteListing]);

const onRefresh = async()=>{
    await getFeesVotes(true);
}
    
const onDelete = async(voteInfo)=>{
    setSelectedVote(voteInfo);
    setShowDeleteFeesVote(true);
  }

  const onEdit = (voteInfo)=>{
    openSettings("Edit Fees Vote", "EditFeesVote", voteInfo);
  }



  const confirmDeleteVote = async()=>{
    setShowDeleteFeesVote(false);
    setNotify(<AlertNotification message="Deleting fees vote..." loader={true} />);
    const server_response = await ajaxSchool.deleteFeesVote(selectedVote.id);
    if(server_response.status === "OK"){
      setNotify(<Notification type="success" message={server_response.message} closable={false} />);
      getFeesVotes(true);
    }else{
      setNotify(<Notification type="danger" message={server_response.message} closable={false} />);
    }
  }

  const handleNewVote = ()=>{
    openSettings("New Fees Vote", "NewFeesVote", null, "Save Fees Vote");
  }

  return (
    <>
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Fees Votes"
          description="Manage and configure fees votes for the school."
          iconClass="fa fa-tag"
          sticky={true}
        />

            <div className="billing-action-bar mb-4">
                <div className="action-group-left">
                    <button 
                    className="btn-primary-custom" 
                    onClick={handleNewVote}
                    >
                        <i className="fa fa-plus"></i>
                        <span>New Fees Vote</span>
                    </button>
                    <div className="action-separator"></div>
                    <button className="btn-ghost-custom" onClick={onRefresh}>
                        <i className="fa fa-sync text-success"></i>
                        <span>Refresh List</span>
                    </button>
                </div>
                <div className="action-group-right text-muted font-size-sm">
                    Total Votes: <strong>{votes.length}</strong>
                </div>
            </div>

      
        <div className="row overflow-auto" style={{maxHeight: "60vh"}}>
            {votes.map((vote, index) => (
                <div className="col-md-12 mb-3" key={vote.id}>
                    <div className="vote-card shadow-sm">
                        <div className="vote-indicator">{index + 1}</div>
                        
                        <div className="vote-info">
                            <h5 className="vote-name">{vote.vote_name}</h5>
                            <span className="badge badge-soft-indigo">Revenue Stream</span>
                        </div>

                        <div className="account-details">
                            <div className="detail-item">
                                <small>Collection Account</small>
                                <div className="account-pill">
                                    <i className="fa fa-university"></i>
                                    <strong>{vote.collection_account.account_name}</strong>
                                    <span className="acc-num">({vote.collection_account.account_number})</span>
                                </div>
                            </div>
                            
                            <div className="detail-item">
                                <small>Asset Account (Receivable)</small>
                                <div className="account-pill">
                                    <i className="fa fa-file-invoice-dollar"></i>
                                    <strong>{vote.asset_account.account_name}</strong>
                                    <span className="acc-num">({vote.asset_account.account_number})</span>
                                </div>
                            </div>
                        </div>

                        <div className="vote-actions">
                            <button className="btn-icon-edit" onClick={() => onEdit(vote)} title="Edit">
                                <i className="fas fa-pen"></i>
                            </button>
                            <button className="btn-icon-delete" onClick={() => onDelete(vote)} title="Delete">
                                <i className="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>

        
      </MainContent>
    </PageContainer>

    <ConfirmationDialog
        title="Delete Fees Vote"
        alertDescription="Are you sure you want to delete this fees vote?"
        notes="If the fees vote is assigned to any fees group, the vote cannot be deleted."
        show={showDeleteFeesVote}
        handleClose={()=>setShowDeleteFeesVote(false)}
        handleConfirm={()=>confirmDeleteVote()}
        buttonLabel="Delete Vote"
        value={selectedVote ? selectedVote.vote_name : ""}
        />

</>
  );
};

export default FeesVotesPage;
